<template>
  <BaseModal
    :show="isOpen"
    size="sm"
    :title="isEditing ? $t('app.views.tables.modal.edit_title') : $t('app.views.tables.modal.add_title')"
    :show-actions="true"
    :is-editing="isEditing"
    :loading="loading"
    @close="closeModal"
    @save="saveTable"
  >
    <div class="space-y-4">
      <div>
        <label
          for="tableNumber"
          class="block text-sm font-medium text-gray-700 dark:text-gray-300 text-left"
        >
          {{ $t('app.views.tables.modal.fields.table_number') }}
        </label>
        <input
          id="tableNumber"
          v-model="formData.number"
          type="text"
          class="mt-1 block w-full px-3 py-2 rounded-md border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:text-white shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          :placeholder="$t('app.views.tables.modal.fields.table_number_placeholder')"
        >
      </div>
      <div>
        <label
          for="capacity"
          class="block text-sm font-medium text-gray-700 dark:text-gray-300 text-left"
        >
          {{ $t('app.views.tables.modal.fields.capacity') }}
        </label>
        <select
          id="capacity"
          v-model="formData.capacity"
          class="mt-1 block w-full px-3 py-2 rounded-md border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:text-white shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        >
          <option
            v-for="n in 10"
            :key="n"
            :value="n"
          >
            {{ n }} {{ n === 1 ? $t('app.views.tables.modal.fields.person') : $t('app.views.tables.modal.fields.people') }}
          </option>
        </select>
      </div>
      <div>
        <label
          for="location"
          class="block text-sm font-medium text-gray-700 dark:text-gray-300 text-left"
        >
          {{ $t('app.views.tables.modal.fields.location_optional') }}
        </label>
        <input
          id="location"
          v-model="formData.location"
          type="text"
          class="mt-1 block w-full px-3 py-2 rounded-md border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:text-white shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          :placeholder="$t('app.views.tables.modal.fields.location_placeholder')"
        >
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import BaseModal from '@/components/common/BaseModal.vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  table: {
    type: Object,
    default: () => ({}),
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'save']);

interface TableForm {
  id: string;
  number: string;
  capacity: number;
  location: string;
}

const formData = ref<TableForm>({
  id: '',
  number: '',
  capacity: 2,
  location: '',
});

const loading = ref(false);

watch(
  () => props.table as any,
  (newTable) => {
    const src = (newTable || {}) as Partial<TableForm> & Record<string, any>;
    formData.value = {
      id: src.id ? String(src.id) : '',
      number: src.number ? String(src.number) : '',
      capacity: typeof src.capacity === 'number' ? src.capacity : 2,
      location: src.location ? String(src.location) : '',
    };
  },
  { immediate: true }
);

const closeModal = () => {
  emit('close');
};

const saveTable = () => {
  emit('save', { ...formData.value });
  closeModal();
};
</script>
